<cradua-upload-document
  [completed]="completed$ | async"
  [progress]="progress$ | async"
  [error]="error$ | async"
  [isInProgress]="isInProgress$ | async"
  [isReady]="isReady$ | async"
  [hasFailed]="hasFailed$ | async"
  (emitUpload)="uploadFile($event)"
  (emitCancel)="cancelUpload($event)"
  (emitReset)="resetUpload($event)"
>
</cradua-upload-document>
